import React from "react";

import PaymentGateway from "../assets/images/Payment gateway.png";
import Prometheus from "../assets/images/Prometheus.png";
import Medium from "../assets/images/Medium.png";
import CovidTracker from "../assets/images/Covid tracker.png";
import ZapierClone from "../assets/images/ZapierClone.png";
import "../assets/styles/Project.scss";

function Project() {
  return (
    <div className="projects-container" id="projects">
      <h1>Personal Projects</h1>
      <div className="projects-grid">
        <div className="project">
          <a
            href="https://github.com/Abhishek9111/zapier-clone"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={ZapierClone}
              className="zoom"
              alt="thumbnail"
              width="100%"
            />
          </a>
          <a
            href="https://github.com/Abhishek9111/Covid-Tracker"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Zapier inspired end-to-end Automation platform</h2>
          </a>
          <p>
            This project is an end-to-end backend system clone that leverages
            Kafka for event streaming, Postgres for database management, Node.js
            for server-side logic, and Next.js for the frontend. It serves as a
            comprehensive example of integrating these technologies to build a
            robust and scalable backend system.
          </p>
        </div>
        <div className="project">
          <a
            href="https://github.com/Abhishek9111/Advanced-payment-gateway"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={PaymentGateway}
              className="zoom"
              alt="thumbnail"
              width="100%"
            />
          </a>
          <a
            href="https://github.com/Abhishek9111/Advanced-payment-gateway"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Payment gateway with Dummy bank server</h2>
          </a>
          <p>
            Developed a payment gateway server with Turborepo based a
            architecture created a dummy bank server to understand how webhook
            api call is implemented at backendand implemented row locking, on
            ramping to dive deep into architecture.
          </p>
        </div>
        <div className="project">
          <a
            href="https://github.com/Abhishek9111/Grafana-Prometheus-Monitoring"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={Prometheus}
              className="zoom"
              alt="thumbnail"
              width="100%"
            />
          </a>
          <a
            href="https://github.com/Abhishek9111/Grafana-Prometheus-Monitoring"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Prometheus + Grafana monitoring</h2>
          </a>
          <p>
            Implemented freely available Prometheus and grafana architecture on
            a dummy nodejs application to undestand how logging can be done at a
            bigger scale and reducing the overhead cost of paid services.
          </p>
        </div>
        <div className="project">
          <a
            href="https://github.com/Abhishek9111/medium-clone"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Medium} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <a
            href="https://github.com/Abhishek9111/medium-clone"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Medium clone</h2>
          </a>
          <p>
            A clone of popular blogging website medium, created using honojs
            backend and api published over cloudfare, implemented frontend and
            used postgresdb for storing data and performing migrations.
          </p>
        </div>
        <div className="project">
          <a
            href="https://github.com/Abhishek9111/Covid-Tracker"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={CovidTracker}
              className="zoom"
              alt="thumbnail"
              width="100%"
            />
          </a>
          <a
            href="https://github.com/Abhishek9111/Covid-Tracker"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Covid tracker</h2>
          </a>
          <p>
            A simple covid tracker application created using ReactJs libary to
            fetch latest stats of covid-19 and also visually display them using
            graphjs and chartjs.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Project;
